import React from 'react';
import loadable from '@loadable/component';

import productAlertQuery from './query.graphql';
import type { Props } from './product-alert';

const ProductAlert = loadable(
  () => import(/* webpackChunkName: "product-alert" */ './product-alert')
);

const ProductAlertPage = (props: Props) => <ProductAlert {...props} />;

ProductAlertPage.graphQL = productAlertQuery;

ProductAlertPage.loadOrder = [{}];

type ProductAlertVariables = {
  id: string;
};

ProductAlertPage.variables = ({ id }: ProductAlertVariables) => ({
  id: parseInt(id, 10),
});

export default ProductAlertPage;
